import { QueryFactory } from "../../../../Common";
import { SD } from "../../../../Contracts";
export const QGetEventsByEventIdForBetSlip = QueryFactory(SD.QueryTypes.GetEventsByEventIdForBetSlip);
//# sourceMappingURL=QGetEventsByEventIdForBetSlip.js.map